__turbopack_context__.v({
  "alternate": "Button-module-scss-module__UGEBqG__alternate",
  "alternateNegative": "Button-module-scss-module__UGEBqG__alternateNegative",
  "alternatePositive": "Button-module-scss-module__UGEBqG__alternatePositive",
  "blink": "Button-module-scss-module__UGEBqG__blink",
  "button": "Button-module-scss-module__UGEBqG__button",
  "icon": "Button-module-scss-module__UGEBqG__icon",
  "loading": "Button-module-scss-module__UGEBqG__loading",
  "negative": "Button-module-scss-module__UGEBqG__negative",
  "positive": "Button-module-scss-module__UGEBqG__positive",
  "secondAlternate": "Button-module-scss-module__UGEBqG__secondAlternate",
  "selected": "Button-module-scss-module__UGEBqG__selected",
  "special": "Button-module-scss-module__UGEBqG__special",
  "thirdAlternate": "Button-module-scss-module__UGEBqG__thirdAlternate",
});
